export default __webpack_public_path__ + "static/media/heading3.8b255182.svg";